import { BaseModel } from "sjs-base-model";
import { formatDate } from "../../utilities/TimeUtility";

 export default class ApiKeyListModel extends BaseModel{
    
    public apiId: string = '';
    public userId: string = '';
    public createDate: string = '';
    public expiryDate: string = ''; 
   
    
    constructor(data: Partial<ApiKeyListModel>) {
      super();
      this.update({
        apiId: data.apiId,
        userId: data.userId,
        createDate: formatDate(data.createDate || ''),
        expiryDate: formatDate(data.expiryDate || ''),
    }); 
  }
}

